import { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import Autocomplete, { AutocompleteProps } from 'components/Autocomplete';
import { WhatToSeeSelect_data$key } from '__generated__/WhatToSeeSelect_data.graphql';

type Props = Omit<AutocompleteProps, 'options'> & {
  data: WhatToSeeSelect_data$key;
};

const WhatToSeeSelect: FC<Props> = props => {
  const { data, ...rest } = props;

  const { allWhatToSees } = useFragment(
    graphql`
      fragment WhatToSeeSelect_data on Query {
        allWhatToSees {
          id
          name
        }
      }
    `,
    data
  );

  return <Autocomplete options={allWhatToSees} {...rest} />;
};

export default WhatToSeeSelect;
